module.exports = __webpack_public_path__ + "media/images/user-a646f3cd4fd14b199a5029d429e2b62f.svg";